/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { getLitigationCaseBadges } from "./getLitigationCaseBadges";
import { getCaseLink } from "../ProductService/productService";
import { Badge } from "../../../types/Badge";
import { AdministrativeLawLitigationCaseUnion } from "../../../types/AdministrativeLawLitigationCaseUnion";

export const getAdministrativeLitigationLawCaseBadges = (product: AdministrativeLawLitigationCaseUnion) => {
  let badges: Badge[] = [];

  if (product.linkedAdministrativeLawCaseIds["expeditedProceedingCaseId"]) {
    badges.push({
      text: "Eilverfahren",
      isActive: product.administrativeCaseType === "expeditedProceeding",
      lbProductId: product.linkedAdministrativeLawCaseIds["expeditedProceedingCaseId"],
      linkTo: getCaseLink({
        productClassName: product.productClassName,
        id: product.linkedAdministrativeLawCaseIds["expeditedProceedingCaseId"],
      }),
    });
  }

  if (product.linkedAdministrativeLawCaseIds["failureToActLawsuitCaseId"]) {
    badges.push({
      text: "Untätigkeitsklage",
      isActive: product.administrativeCaseType === "failureToActLawsuit",
      lbProductId: product.linkedAdministrativeLawCaseIds["failureToActLawsuitCaseId"],
      linkTo: getCaseLink({
        productClassName: product.productClassName,
        id: product.linkedAdministrativeLawCaseIds["failureToActLawsuitCaseId"],
      }),
    });
  }

  if (product.linkedAdministrativeLawCaseIds["mainCaseId"]) {
    badges.push({
      text: "Hauptverfahren",
      isActive: product.administrativeCaseType === "main",
      lbProductId: product.linkedAdministrativeLawCaseIds["mainCaseId"],
      linkTo: getCaseLink({
        productClassName: product.productClassName,
        id: product.linkedAdministrativeLawCaseIds["mainCaseId"],
      }),
    });
  }

  return [...badges, ...getLitigationCaseBadges(product)];
};
